<ion-header [hidden]="scanCamera">
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title></ion-title>
        <ion-buttons slot="start">
            <span show-md  style="padding-left: 0px; padding-right: 10px;">Order</span>
            <input
                #inpProjnrRef
                list='ordlisting'
                placeholder="Order nummer"
                class="inputField" style="width: 10em;"
                onclick="this.select();"
                (input)='projChanged($any($event.target).value)'
                [(ngModel)]='inpProjnr'
                [disabled]="global.usrlevel<global.var['app-orders-actueel-niveau']"
            >
            <ion-button (click)="doClearProj()" color="primary" fill="solid"
                *ngIf="global.usrlevel>=global.var['app-orders-actueel-niveau']"
            >
                <ion-icon name="search"></ion-icon>
            </ion-button>
            <ion-button (click)="doClearProj()" color="primary" fill="solid"
                *ngIf="global.usrlevel<global.var['app-orders-actueel-niveau']"
            >
                <ion-icon name="sync-outline"></ion-icon>
            </ion-button>
            <ion-button (click)="doScanProj()" [hidden]="global.optHideScanBtn" color="primary" fill="solid"
                *ngIf="global.usrlevel>=global.var['app-orders-actueel-niveau']"
            >
                <ion-icon name="barcode"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content [hidden]="scanCamera">
    <mat-card-content *ngIf="ordernr==''">
        <mat-tab-group [(selectedIndex)]="searchTab" (click)="onChangeTabProj()">
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon>assignment</mat-icon>
                    <span show-md>Ingepland</span>
                </ng-template>
                <div>
                    <div *ngIf="ordersPlan.length==0">Niet ingepland op planbord</div>
                    <table class='clickable'>
                        <tr *ngFor="let proj of ordersPlan">
                            <td (click)="click_proj(proj.nr)" class="link">{{proj.pbDatum}}</td>
                            <td (click)="click_proj(proj.nr)" class="link">{{proj.pbAanvang.substr(0,5)}}</td>
                            <td (click)="click_proj(proj.nr)">{{proj.nr}}</td>
                            <td (click)="click_proj(proj.nr)">{{proj.descr}}</td>
                        </tr>
                    </table>
                </div>
            </mat-tab>
            <mat-tab *ngIf="global.usrlevel>=global.var['app-orders-actueel-niveau']">
                <ng-template mat-tab-label>
                    <mat-icon>outbox</mat-icon>
                    <span show-md>Actueel</span>
                </ng-template>
                <div>
                    <table class='clickable' *ngIf="projlist.length">
                        <tr *ngFor="let proj of projlist">
                            <td (click)="click_proj(proj.nr)">{{proj.des}}</td>
                        </tr>
                    </table>
                </div>
            </mat-tab>
            <mat-tab *ngIf="global.usrlevel>=global.var['app-orders-afgesloten-niveau']">
                <ng-template mat-tab-label>
                    <mat-icon>all_inbox</mat-icon>
                    <span show-md>Alles</span>
                </ng-template>
                <div>
                    <table class='clickable' *ngIf="projlist.length">
                        <tr *ngFor="let proj of projlist">
                            <td (click)="click_proj(proj.nr)">{{proj.des}}</td>
                        </tr>
                    </table>
                </div>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>

    <mat-card>
        <mat-card-content *ngIf="ordernr!=''">
            <mat-tab-group>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <ion-icon name="clipboard" class="tabicon"></ion-icon>
                        <span show-md>Gegevens</span>
                    </ng-template>
                    <table class="taglist">
                        <tr *ngFor="let fld of fields">
                            <td>
                                <ion-button size="small" *ngIf="fld.tag==='Instructie' && !editInstr" (click)="editInstr=true" >
                                    <ion-icon name="pencil"></ion-icon>
                                </ion-button>
                                <a *ngIf="fld.tag==='Telefoon' && fld.value>''" [href]="'tel:'+fld.value">
                                    <ion-button size="small"><ion-icon name="call"></ion-icon></ion-button>
                                </a>
                                <a *ngIf="fld.tag==='Adres' && fld.value>''" target="_system" [href]=mapsUrl(fld.value)>
                                    <ion-button size="small"><ion-icon name="location"></ion-icon></ion-button>
                                </a>
                                <ion-button size="small" *ngIf="fld.link" (click)="router.navigate([fld.link])">
                                    <ion-icon name="attach"></ion-icon>
                                </ion-button>
                            </td>
                            <td class="tag">{{fld.tag}}</td>
                            <td class="value">
                                <span *ngIf="fld.tag!=='Instructie' || !editInstr" style="white-space: pre-wrap;">{{fld.value}}</span>
                                <span *ngIf="fld.tag==='Instructie' && editInstr">
                                    <textarea (change)="chInstructie()" [(ngModel)]="ordInstr.value"></textarea>
                                </span>
                            </td>
                            <td class="mobile">
                                <span class="tag">{{fld.tag}}</span><br>
                                <span *ngIf="fld.tag!=='Instructie' || !editInstr" style="white-space: pre-wrap;">{{fld.value}}</span>
                                <span *ngIf="fld.tag==='Instructie' && editInstr">
                                    <textarea (change)="chInstructie()" [(ngModel)]="ordInstr.value"></textarea>
                                </span>
                            </td>
                        </tr>
                    </table>
                </mat-tab>
                <mat-tab *ngIf="global.getvar('app-order-tab-foto', '1')=='1'">
                    <ng-template mat-tab-label>
                        <ion-icon name="image" class="tabicon"></ion-icon>
                        <span show-md>Foto's</span>
                    </ng-template>
                    <ion-row>
                        <ion-col size="auto">
                            <ion-button expand="block" (click)="doMkdir()">
                                <ion-icon name="folder-outline" size="large"></ion-icon>&nbsp;Nieuwe map
                            </ion-button>
                        </ion-col>
                        <ion-col size="auto">
                            <ion-button expand="block" (click)="doUpload()">
                                <ion-icon name="cloud-upload-outline" size="large"></ion-icon>&nbsp;Upload
                            </ion-button>
                        </ion-col>
                    </ion-row>
                    <input type="file" #fileUpload id="fileUpload" name="fileUpload" multiple="multiple" accept="image/*"
                        style="display:none;" />
                    <mat-grid-list [cols]="gridCols" (window:resize)="onResize()">
                        <mat-grid-tile *ngIf="currSub!==''" (click)="doChDir('..')">
                            <mat-icon class='bigicon'>drive_folder_upload</mat-icon>
                            <mat-grid-tile-footer>Map omhoog</mat-grid-tile-footer>
                        </mat-grid-tile>
                        <mat-grid-tile *ngIf="loadingImgs">
                            <mat-spinner></mat-spinner>
                            <mat-grid-tile-footer>Loading ...</mat-grid-tile-footer>
                        </mat-grid-tile>
                        <mat-grid-tile *ngFor="let dir of dirs" (click)="doChDir(dir.filename)">
                            <mat-icon class='bigicon'>folder</mat-icon>
                            <mat-grid-tile-footer>{{dir.filename}}</mat-grid-tile-footer>
                        </mat-grid-tile>
                        <mat-grid-tile *ngFor="let file of files">
                            <mat-progress-bar [value]="file.progress" *ngIf="file.inProgress"></mat-progress-bar>
                            <mat-grid-tile-footer>{{file.data.name}}</mat-grid-tile-footer>
                        </mat-grid-tile>
                        <mat-grid-tile *ngFor="let file of imgs; index as i" (click)="viewerOpen=true; idx=i">
                            <img mat-card-image src="{{global.baseurl + 'doc.php?src=' +file.path}}" layout-fill>
                            <mat-grid-tile-footer>
                                <div class="iconmenu" (click)="fileMenu(i, file, $event)">
                                    <mat-icon>more_vert</mat-icon>
                                </div>
                                <div>{{file.txt}}</div>
                            </mat-grid-tile-footer>
                        </mat-grid-tile>
                        <mat-grid-tile *ngFor="let file of docs; index as i"
                            (click)="openFile(global.baseurl + 'doc.php?src=' +file.path)"
                        >
                            <mat-icon class='bigicon' [innerHTML]="file.ext=='pdf' ? 'picture_as_pdf' : 'description'"></mat-icon>
                            <mat-grid-tile-footer>
                                <div class="iconmenu" (click)="fileMenu(i, file, $event)">
                                    <mat-icon>more_vert</mat-icon>
                                </div>
                                <div>{{file.filename}}</div>
                            </mat-grid-tile-footer>
                        </mat-grid-tile>
                        <div [matMenuTriggerFor]="filemenu" id="filemenuID"></div>

                        <mat-menu #filemenu="matMenu">
                            <button mat-menu-item (click)="viewerOpen=true" *ngIf="currFile['typ']==='img'">
                                <mat-icon>fullscreen</mat-icon>
                                <span>View</span>
                            </button>
                            <button mat-menu-item (click)="fileDelete()">
                                <mat-icon>delete</mat-icon>
                                <span>Delete</span>
                            </button>
                        </mat-menu>
                    </mat-grid-list>
                </mat-tab>
                <mat-tab *ngIf="global.getvar('app-order-tab-uren', '1')=='1'">
                    <ng-template mat-tab-label>
                        <ion-icon name="time" class="tabicon"></ion-icon>
                        <span show-md>Uren</span>
                    </ng-template>
                    <ion-row>
                        <ion-col size="auto">
                            <ion-button expand="block" (click)="addUren()" [disabled]="!projData.OrderActief">
                                <ion-icon name="add-circle" size="large"></ion-icon> Nieuw
                            </ion-button>
                        </ion-col>
                    </ion-row>
                    <mat-card>
                        <table class='afstand'>
                            <tr>
                                <th>Datum</th>
                                <th>Door</th>
                                <th>Uren</th>
                                <th></th>
                                <th></th>
                            </tr>
                            <tr *ngFor="let lin of uren">
                                <td align="right" valign="top" class='link'
                                    (click)="editUren(lin.ID)"
                                    style="white-space: nowrap;"
                                >
                                    {{lin.DD}}
                                </td>
                                <td valign="top">{{lin.IDpersoon}}</td>
                                <td align="right" valign="top">{{lin.Uren}}</td>
                                <td valign="top" width="100%">{{lin.Omschr}}</td>
                            </tr>
                        </table>
                    </mat-card>
                </mat-tab>
                <mat-tab *ngIf="global.getvar('app-order-tab-art', '1')=='1'">
                    <ng-template mat-tab-label>
                        <ion-icon name="cart" class="tabicon"></ion-icon>
                        <span show-md>Artikelen</span>
                    </ng-template>
                    <ion-row>
                        <ion-col size="auto">
                            <ion-button expand="block" (click)="goAfboeken()" [disabled]="!projData.OrderActief">
                                <ion-icon name="add-circle" size="large"></ion-icon>&nbsp;Afboeken
                            </ion-button>
                        </ion-col>
                    </ion-row>
                    <mat-card>
                        <table class='afstand'>
                            <tr>
                                <th>Datum</th>
                                <th>Qty</th>
                                <th>Art.Nr.</th>
                                <th>Omschrijving</th>
                            </tr>
                            <tr *ngFor="let lin of artikelen" (click)="(lin.amSoort=='R' || lin.amSoort=='W') && dlgRtoB(lin.Qty, lin.amArtNr, lin.Eenheid)" [ngClass]="{'gereserveerd': lin.amSoort=='R' || lin.amSoort=='W'}">
                                <td valign="top" align="right" style="white-space: nowrap;">{{lin.amDD}}</td>
                                <td valign="top" align="right">{{lin.Qty}}</td>
                                <td valign="top">{{lin.amArtNr}}</td>
                                <td valign="top" width="100%">{{lin.Omschr}}</td>
                            </tr>
                        </table>
                    </mat-card>
                    <mat-card *ngIf="(ingekocht.length)">
                        <h4>Ingekocht voor order</h4>
                        <table class='afstand'>
                            <tr>
                                <th>Qty</th>
                                <th></th>
                                <th>Omschrijving</th>
                            </tr>
                            <tr *ngFor="let lin of ingekocht">
                                <td valign="top" align="right">{{lin.Qty}}</td>
                                <td valign="top">{{lin.POLeenh}}</td>
                                <td valign="top">{{lin.POLdescr}}</td>
                            </tr>
                        </table>
                    </mat-card>
                </mat-tab>


                <mat-tab *ngIf="global.getvar('app-order-tab-opdracht', '0')=='1'">
                    <ng-template mat-tab-label>
                        <mat-icon>shopping_cart</mat-icon>
                        <span show-md>Opdracht</span>
                    </ng-template>
                    <button mat-raised-button color="primary" *ngIf="!ordrLineEdit" (click)="ordrNwLine()" style="margin: 8px;"
                        [disabled]="projData.OrderType!=='O'"
                    >
                        <mat-icon>add_circle</mat-icon> Toevoegen
                    </button>
                    <mat-card *ngIf="ordrLineEdit">
                        Selecteer een artikel ...<br>
                        <img [src]='ordrArtShowImg' style="position: absolute; right: 0; max-height: 35vh; overflow: hidden;">
                        <table class="afstand" width="100%">
                            <tr>
                                <td><span class="tag">Aantal</span></td>
                                <td>
                                    <mat-form-field style="width: 40px;">
                                        <input type='number' matInput [(ngModel)]="ordrQty">
                                    </mat-form-field>
                                </td>
                                <td><span class="tag">Artikel nr.</span></td>
                                <td>
                                    <mat-form-field>
                                        <input matInput [matAutocomplete]="auto" [(ngModel)]="ordrArtnr"
                                            (input)='artChanged($any($event.target).value)'
                                        >
                                        <mat-autocomplete #auto="matAutocomplete"
                                            panelWidth='400px'
                                            onclick="this.select()"
                                            (optionSelected)='artChanged($event.option.value)'
                                        >
                                            <mat-option *ngFor="let lst of ordrArtChoices" [value]="lst.ID">
                                                <span>{{lst.ID}}: {{lst.txt}}</span>
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                </td>
                            </tr>
                            <tr>
                                <td class="tag">Toelichting</td>
                                <td colspan="3"><mat-form-field style="width: 300px"><input matInput [(ngModel)]="ordrOms"></mat-form-field></td>
                            </tr>
                            <tr>
                                <td class="tag">Omschrijving</td>
                                <td colspan="3">{{ordrArtShow['des']}}</td>
                            </tr>
                            <tr *ngIf="!global.optInclBtw">
                                <td class="tag">Prijs (excl BTW)</td>
                                <td colspan="3">{{ordrArtShow['prys']}}</td>
                            </tr>
                            <tr *ngIf="global.optInclBtw">
                                <td class="tag">Prijs (incl BTW)</td>
                                <td colspan="3">{{ordrArtShow['prysincl']}}</td>
                            </tr>
                            <tr>
                                <td class="tag">Voorraad</td>
                                <td colspan="3">{{ordrArtShow['vvrd']}} <span *ngIf="ordrArtShow['vrde']">+ elders: {{ordrArtShow['vrde']}}</span></td>
                            </tr>
                        </table>
                        <button mat-button color="primary" (click)="ordrLineEdit=false" style="margin: 8px;">
                            <mat-icon>cancel</mat-icon> Cancel
                        </button>
                        <button mat-raised-button color="primary" [disabled]="!ordrArtShow['artnr'] && !ordrOms" (click)="ordrSaveLine()" style="margin: 8px;">
                            <mat-icon>{{(ordrQty==0) ? 'delete': 'check'}}</mat-icon> {{(ordrQty==0) ? 'Verwijder': 'OK'}}
                        </button>
                    </mat-card>
                    <mat-card>
                        <span *ngIf="projData.OrderType=='O'">Concept opdracht:</span>
                        <table class='afstand'>
                            <tr>
                                <th>Qty</th>
                                <th>Art.Nr.</th>
                                <th>Omschr.</th>
                                <th *ngIf="!global.optInclBtw">Prijs (excl.)</th>
                                <th *ngIf="global.optInclBtw">Prijs (incl.)</th>
                                <th>Voorraad</th>
                            </tr>
                            <tr *ngFor="let lin of artikelen" [ngClass]="{'gereserveerd': lin.amSoort=='R'}">
                                <td valign="top" align="right">{{lin.Qty}}</td>
                                <td valign="top" *ngIf="projData.OrderType=='O'" (click)="ordrEditLine(lin)" class="link">{{lin.amArtNr}}</td>
                                <td valign="top" *ngIf="projData.OrderType!=='O'">{{lin.amArtNr}}</td>
                                <td valign="top">{{(lin.amArtNr=='x') ? lin.amOpm : lin.Omschr}}</td>
                                <td valign="top" align="right" *ngIf="!global.optInclBtw">{{lin.Verkoopprijs }}</td>
                                <td valign="top" align="right" *ngIf="global.optInclBtw">{{lin.VerkoopprijsIncl }}</td>
                                <td valign="top" align="center" *ngIf="lin.amArtNr!='x'">
                                    <span class="material-icons tinyicon" *ngIf="+lin.Qty<=+lin.vvrd" style="color: green" title="voorradig">check_circle</span>
                                    <span class="material-icons tinyicon" *ngIf="+lin.Qty>+lin.vvrd && +lin.Qty<=+lin.vvrd + +lin.vrde" style="color: orange" title="elders voorradig">check_circle</span>
                                    <span class="material-icons tinyicon" *ngIf="+lin.Qty>+lin.vvrd + +lin.vrde" style="color: red" title="momenteel niet voorradig">hourglass_empty</span>
                                </td> <!-- in winkel voorradig=groene vink, elders voorradig=oranje vink, niet voorradig=rode zandloper -->
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td>SUBTOTAAL</td>
                                <td align="right" *ngIf="!global.optInclBtw">{{subtotalExclDispl}}</td>
                                <td align="right" *ngIf="global.optInclBtw">{{subtotalInclDispl}}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td>Korting
                                    <mat-form-field style="width: 40px;">
                                        <input type='number' matInput [(ngModel)]="projData.KlantKorting" (change)="calcTotal()" [disabled]="projData.OrderType!=='O'">
                                    </mat-form-field> %
                                </td>
                                <td align="right" *ngIf="!global.optInclBtw">{{kortingExclDispl}}</td>
                                <td align="right" *ngIf="global.optInclBtw">{{kortingInclDispl}}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td>TOTAAL</td>
                                <td align="right" *ngIf="!global.optInclBtw">{{totalExclDispl}}</td>
                                <td align="right" *ngIf="global.optInclBtw">{{totalInclDispl}}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td>Aanbetaling</td>
                                <td align="right">
                                    <mat-form-field style="width: 120px;">
                                        <input type='number' matInput [(ngModel)]="opdracht.aanbetaling" [disabled]="projData.OrderType!=='O'" >
                                    </mat-form-field>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td valign="top">Betaalwijze</td>
                                <td>
                                    <mat-radio-group [(ngModel)]="opdracht.betaalwijze" [disabled]="projData.OrderType!=='O'">
                                        <mat-radio-button value="PIN">PIN</mat-radio-button><br>
                                        <mat-radio-button value="BANK">Bank overschrijving</mat-radio-button><br>
                                        <mat-radio-button value="CASH">Contant</mat-radio-button>
                                    </mat-radio-group>
                                </td>
                            </tr>
                        </table>
                        <span [hidden]="projData.OrderType!=='O'">
                            Handtekening opdrachtgever:<br>
                            <canvas #signOpdr (touchstart)="drawStart($event)" (touchmove)="drawMoved($event)" (touchend)="drawEnd()"></canvas>
                            <button mat-button color="primary" (click)="drawClearOpdr()">
                                <mat-icon>cancel</mat-icon> Cancel
                            </button>
                            <button mat-raised-button color="primary" (click)="opdrachtSave()" [disabled]="!opdracht.betaalwijze">
                                <mat-icon>check</mat-icon> OK
                            </button>
                        </span>
                    </mat-card>
                </mat-tab>

                <mat-tab *ngIf="global.getvar('app-order-tab-werkbon', '1')=='1'">
                    <ng-template mat-tab-label>
                        <ion-icon name="pencil" class="tabicon"></ion-icon>
                        <span show-md>Werkbon</span>
                    </ng-template>

                    <ion-row *ngIf="prevBonnen.length>0 && !newBon">
                        <ion-col size="auto">
                            <ion-button expand="block" (click)="newBon=true">
                                <ion-icon name="add-circle" size="large"></ion-icon>&nbsp;Nieuw
                            </ion-button>
                        </ion-col>
                    </ion-row>

                    <mat-card *ngIf="prevBonnen.length>0 && !newBon">
                        Reeds ondertekende bonnen:<br>
                        <table class='afstand'>
                            <tr>
                                <th>Datum</th>
                                <th></th>
                                <th>Door</th>
                                <th>Gereed</th>
                                <th></th>
                            </tr>
                            <tr *ngFor="let lin of prevBonnen">
                                <td align="right" class="link" (click)="openWerkbon(lin.ID)" style="white-space: nowrap;">{{lin.DD}}</td>
                                <td style="white-space: nowrap;">{{lin.Tijd}}</td>
                                <td style="white-space: nowrap;">{{lin.Door}}</td>
                                <td>{{ (lin.Gereed=='1') ? 'J' : 'N' }}</td>
                                <td width="100%">{{lin.Opmerking}}</td>
                            </tr>
                        </table>
                    </mat-card>
                    <mat-card [hidden]="prevBonnen.length>0 && !newBon">
                        <h2>Werkbon</h2>
                        <div *ngIf="werkbon.lines.length>0">
                            <table class='afstand'>
                                <tr>
                                    <th>Aantal</th>
                                    <th></th>
                                    <th></th>
                                    <th>Omschrijving</th>
                                </tr>
                                <tr *ngFor="let lin of werkbon.lines">
                                    <td align="right">{{lin.Qty}}</td>
                                    <td>{{lin.Eenh}}</td>
                                    <td>{{lin.Code}}</td>
                                    <td>{{lin.Omschr}}</td>
                                </tr>
                            </table>
                        </div>
                        <div>
                            <mat-form-field>
                                <textarea matInput rows="5" placeholder="Opmerking" [(ngModel)]="werkbon.omschr"></textarea>
                            </mat-form-field>
                            <br>
                            <mat-radio-group [(ngModel)]="werkbon.gereed" *ngIf="magGereedmelden">
                                <mat-radio-button value='1'>Order is hierbij gereed</mat-radio-button><br>
                                <mat-radio-button value='0'>Order is nog niet gereed</mat-radio-button><br>
                            </mat-radio-group>
                            <br>
                            <mat-form-field>
                                <input type='text' matInput placeholder="Naam" [(ngModel)]="werkbon.naam">
                            </mat-form-field>
                            <br>
                            <mat-form-field>
                                <input type='text' matInput placeholder="Email" [(ngModel)]="werkbon.email">
                            </mat-form-field>
                            <br>

                            Handtekening opdrachtgever:<br>
                            <canvas #signpad (touchstart)="drawStart($event)" (touchmove)="drawMoved($event)" (touchend)="drawEnd()"></canvas>
                            <ion-row>
                                <ion-col size="auto">
                                    <ion-button expand="block" (click)="drawClear()" fill="outline">
                                        <ion-icon name="close-outline" size="large"></ion-icon>&nbsp;Cancel
                                    </ion-button>
                                </ion-col>
                                <ion-col size="auto">
                                    <ion-button expand="block" (click)="werkbonSave()">
                                        <ion-icon name="checkmark-outline" size="large"></ion-icon>&nbsp;OK
                                    </ion-button>
                                </ion-col>
                            </ion-row>

                        </div>
                    </mat-card>
                </mat-tab>

                <mat-tab *ngIf="formulierFeature">
                    <ng-template mat-tab-label>
                        <ion-icon name="checkbox" class="tabicon"></ion-icon>
                        <span show-md>Formulier</span>
                    </ng-template>
                    <table>
                        <tr>
                            <td width="100%" valign="top">
                                <mat-form-field appearance="fill" style="width: 100%;">
                                    <mat-select [(value)]="formType">
                                        <mat-option *ngFor="let frm of forms" [value]="frm.ID">
                                            {{frm.FormGroep}} {{frm.FormNaam}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td valign="top">
                                <ion-button (click)="router.navigate(['form/NEW'+formType+'/'+ordernr])">
                                    <ion-icon name="create-outline" size="large"></ion-icon>&nbsp;Aanmaken
                                </ion-button>
                            </td>
                        </tr>
                    </table>
                    <div *ngIf="formsAangemaakt && formsAangemaakt.length>0">
                        <table class="clickable">
                            <tr>
                                <th>Formulier</th>
                                <th>Nr.</th>
                                <th>Betreft</th>
                                <th>Door</th>
                                <th>Datum</th>
                                <th>Status</th>
                            </tr>
                            <tr *ngFor="let frm of formsAangemaakt">
                                <td class="link" (click)="router.navigate(['form/'+frm.id])">{{frm.FormGroep}} {{frm.FormNaam}}</td>
                                <td>{{frm.id}}</td>
                                <td>{{frm.verdieping}}</td>
                                <td>{{frm.user}}</td>
                                <td>{{frm.dd}}</td>
                                <td>{{ (frm.vastgelegd=="0000-00-00" ? 'Klad' : 'Vrijgegeven' ) }}</td>
                            </tr>
                        </table>
                    </div>
                </mat-tab>

                <mat-tab *ngIf="global.getvar('app-order-tab-aant', '1')=='1'">
                    <ng-template mat-tab-label>
                        <ion-icon name="chatbox-ellipses" class="tabicon"></ion-icon>
                        <span show-md>Aantekeningen</span>
                    </ng-template>
                    <ion-row>
                        <ion-col size="auto">
                            <ion-button expand="block" (click)="addAantek()">
                                <ion-icon name="add-circle" size="large"></ion-icon>&nbsp;Nieuw
                            </ion-button>
                        </ion-col>
                    </ion-row>
                    <mat-card>
                        <table class='afstand'>
                            <tr>
                                <th>Datum</th>
                                <th>Voor</th>
                                <th align="left">Titel</th>
                            </tr>
                            <tr *ngFor="let lin of aantekeningen">
                                <td align="right" class='link' style="white-space: nowrap;" (click)="editAantek(lin.ID)">{{lin.DueDate}}</td>
                                <td style="white-space: nowrap;">{{lin.Voor}}</td>
                                <td width="100%">{{lin.Titel}}</td>
                            </tr>
                        </table>
                    </mat-card>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
    </mat-card>
</ion-content>
<app-imageview  [open]="viewerOpen" [idx]="idx" [imgs]="imgs" [ordnr]="ordernr" [baseSub]="'/foto'" [currSub]="currSub" (close)="viewerOpen = false; loadImgs()"></app-imageview>
